const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

const isBrowser = () => typeof window !== 'undefined' && Boolean(window.location);

const normalizeBase = (value) => String(value || '').trim().replace(/\/+$/, '');

const isClientLocalBackend = (baseUrl) => {
  if (!baseUrl || !isBrowser()) return false;
  try {
    const parsed = new URL(baseUrl, window.location.origin);
    return LOCAL_HOSTS.has(parsed.hostname) && !LOCAL_HOSTS.has(window.location.hostname);
  } catch (error) {
    return false;
  }
};

export const getApiBaseUrl = () => {
  const configuredBase = normalizeBase(process.env.REACT_APP_BACKEND_URL);

  if (isClientLocalBackend(configuredBase)) {
    return '';
  }

  return configuredBase;
};

export const buildApiUrl = (path = '') => {
  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
};

export const API_BASE_URL = getApiBaseUrl();
